import { render, staticRenderFns } from "./FollowPublicAccount.vue?vue&type=template&id=39c6fa60&scoped=true&"
import script from "./FollowPublicAccount.vue?vue&type=script&lang=js&"
export * from "./FollowPublicAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6fa60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
